export enum Vertical {
  Banking = 'banking',
}

export enum MarketplaceProductTypeEnum {
  Banking = 'BANKING',
}

/** Value on `BankingOfferV2.displayPages` used for paid marketing placements */
export const BANKING_OFFER_DISPLAY_PAGE_DIGITAL_MARKETING = 'DIGITAL_MARKETING';

export const STATES_MAP = {
  AL: 'Alabama',
  AK: 'Alaska',
  AZ: 'Arizona',
  AR: 'Arkansas',
  CA: 'California',
  CO: 'Colorado',
  CT: 'Connecticut',
  DC: 'District of Columbia',
  DE: 'Delaware',
  FL: 'Florida',
  GA: 'Georgia',
  HI: 'Hawaii',
  ID: 'Idaho',
  IL: 'Illinois',
  IN: 'Indiana',
  IA: 'Iowa',
  KS: 'Kansas',
  KY: 'Kentucky',
  LA: 'Louisiana',
  ME: 'Maine',
  MD: 'Maryland',
  MA: 'Massachusetts',
  MI: 'Michigan',
  MN: 'Minnesota',
  MS: 'Mississippi',
  MO: 'Missouri',
  MT: 'Montana',
  NE: 'Nebraska',
  NV: 'Nevada',
  NH: 'New Hampshire',
  NJ: 'New Jersey',
  NM: 'New Mexico',
  NY: 'New York',
  NC: 'North Carolina',
  ND: 'North Dakota',
  OH: 'Ohio',
  OK: 'Oklahoma',
  OR: 'Oregon',
  PA: 'Pennsylvania',
  RI: 'Rhode Island',
  SC: 'South Carolina',
  SD: 'South Dakota',
  TN: 'Tennessee',
  TX: 'Texas',
  UT: 'Utah',
  VT: 'Vermont',
  VA: 'Virginia',
  WA: 'Washington',
  WV: 'West Virginia',
  WI: 'Wisconsin',
  WY: 'Wyoming',
};

export const allStates = Object.keys(STATES_MAP) as (keyof typeof STATES_MAP)[];

/**
 * How far back `BankingOfferV2.history(field: APY)` is asked to reach, and so
 * how far the chart's MAX range can go.
 *
 * Deliberately earlier than any rate on record: the query returns what it has
 * and pads the opening boundary with a null point, so an early `from` costs one
 * point rather than failing.
 */
export const APY_HISTORY_FROM = '2018-01-01';
